import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemText, Paper, Pagination, Typography  } from "@mui/material";
import {USER_ROLES_BY_USER_URL} from './../../../../Constants/Constants';
import AxiosInstance from './../../../../services/AxiosInstance';
import AppTableView from "../../../AppTableView";
import {USER_ROLES_COLUMNS} from "../../../ticket/grid/GridDataConstants";

//const data = Array.from({ length: 20 }, (_, i) => `Item ${i + 1}`); // 50 sample items
const itemsPerPage = 5;

function UserInfoRoles({editUserId, selectedUserName}) {
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {        
    getUserRoles();
  }, []);


  const getUserRoles = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(USER_ROLES_BY_USER_URL + editUserId).then(response => setUserRoles(response.data));          
  }

  return (
    <Paper>
        <AppTableView
            rows={userRoles}
            cols={USER_ROLES_COLUMNS}
            initialPageSize={itemsPerPage}
        />
    </Paper>
  );
};

export default UserInfoRoles;
